import * as React from "react";
import { forwardRef } from "react";
const SvgCrossHair = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 14.5A35.5 35.5 0 0 0 14.5 50 35.5 35.5 0 0 0 50 85.5 35.5 35.5 0 0 0 85.5 50 35.5 35.5 0 0 0 50 14.5m0 6A29.5 29.5 0 0 1 79.5 50 29.5 29.5 0 0 1 50 79.5 29.5 29.5 0 0 1 20.5 50 29.5 29.5 0 0 1 50 20.5" />
    <path d="M46 0h8v35h-8zM46 65h8v35h-8zM100 46v8H65v-8zM35 46v8H0v-8z" />
  </svg>
);
const ForwardRef = forwardRef(SvgCrossHair);
export default ForwardRef;
